module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.21387",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.907",
      "atom": "static-1.1809",
      "autolinker": "static-3.11",
      "browserslist-config-hubspot": "static-1.122",
      "conversations-async-data": "static-2.3903",
      "conversations-error-reporting": "static-1.5223",
      "conversations-http": "static-1.1114",
      "conversations-infrastructure": "static-1.5315",
      "conversations-internal-pub-sub": "static-1.11466",
      "conversations-internal-schema": "static-1.9042",
      "conversations-message-history": "static-1.7224",
      "conversations-prop-types": "static-1.3876",
      "conversations-skeleton-state": "static-1.3733",
      "conversations-test-sdk": "static-1.6824",
      "conversations-visibility-tools": "static-1.2129",
      "conversations-visitor-experience-components": "static-1.14747",
      "conversations-visitor-message-history": "static-1.13481",
      "csstype": "static-1.8",
      "cssUtils": "static-1.308",
      "emoji-regex": "static-1.7",
      "floating-ui": "static-1.5",
      "flux-actions": "static-1.228",
      "foundations-assets": "static-1.1070",
      "foundations-components": "static-1.1947",
      "foundations-theming": "static-1.179",
      "framer-motion": "static-1.21",
      "head-dlb": "static-1.1391",
      "HeadJS": "static-2.459",
      "help-widget-components": "static-1.9026",
      "history": "static-4.15",
      "hs-lodash": "static-4.9",
      "hs-promise-utils": "static-1.1534",
      "hs-story-utils": "static-1.4727",
      "hs-test-utils": "static-1.3859",
      "hub-http-janus": "static-1.512",
      "hub-http-rxjs": "static-1.482",
      "hubspot-dlb": "static-1.1019",
      "hubspotter-http": "static-1.1443",
      "HubStyle": "static-2.7728",
      "HubStyleTokens": "static-2.7418",
      "I18n": "static-7.1189",
      "i18n-data": "static-1.175",
      "icons": "static-2.577",
      "immer": "static-1.33",
      "jasmine": "static-4.795",
      "jasmine-immutable": "static-1.295",
      "jasmine-runner": "static-1.2390",
      "moment-timezone": "static-5.17",
      "msw": "static-1.39",
      "PatternValidationJS": "static-1.437",
      "permission-components": "static-1.1678",
      "quartz": "static-1.2768",
      "react-aria": "static-1.24",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.11707",
      "react-select-plus": "static-1.41",
      "react-transition-group": "static-2.8",
      "react-utils": "static-2.2104",
      "react-virtualized": "static-2.26",
      "redux-mock-store": "static-1.8",
      "redux-thunk": "static-2.17",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "rxjs": "static-5.10",
      "salesImages": "static-1.479",
      "sanitize": "static-1.6",
      "sanitize-text": "static-1.4556",
      "sassPrefix": "static-1.110",
      "signup-constants": "static-1.11297",
      "signup-ui-lego-core": "static-1.13309",
      "signup-ui-url-generator": "static-2.4275",
      "StyleGuideUI": "static-3.409",
      "tanstack-table": "static-1.1",
      "testing-library": "static-1.102",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.5866",
      "ui-fonts": "static-1.322",
      "ui-images": "static-2.708",
      "UIComponents": "static-3.4369",
      "urlinator": "static-1.999",
      "usage-tracker": "static-1.3310",
      "usage-tracker-anonymous": "static-1.1727",
      "usage-tracker-core": "static-1.3160",
      "usage-tracker-multi": "static-1.1726",
      "usage-tracker-public": "static-1.3121",
      "viral-links-lib": "static-1.2446",
      "visitor-ui-component-library": "static-1.2653",
      "visitor-ui-component-library-icons": "static-1.2463",
      "webpack-env": "static-1.4",
      "classnames": "static-2.10",
      "enviro": "static-4.247",
      "hub-http": "static-1.2184",
      "immutable": "static-2.19",
      "metrics-js": "static-1.4861",
      "PortalIdParser": "static-2.227",
      "raven": "static-3.1416",
      "react": "static-7.123",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "styled-components": "static-2.40",
      "hs-promise-rejection-tracking": "static-1.1385",
      "raven-hubspot": "static-1.1723",
      "hoist-non-react-statics": "static-3.9",
      "hubspot-url-utils": "static-1.647",
      "moment": "static-3.26",
      "bend-plugin-uicomponents": "static-1.498"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.21387",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.907",
      "atom": "/atom/static-1.1809",
      "autolinker": "/autolinker/static-3.11",
      "browserslist-config-hubspot": "/browserslist-config-hubspot/static-1.122",
      "conversations-async-data": "/conversations-async-data/static-2.3903",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.5223",
      "conversations-http": "/conversations-http/static-1.1114",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.5315",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.11466",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.9042",
      "conversations-message-history": "/conversations-message-history/static-1.7224",
      "conversations-prop-types": "/conversations-prop-types/static-1.3876",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.3733",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.6824",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.2129",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.14747",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.13481",
      "csstype": "/csstype/static-1.8",
      "cssUtils": "/cssUtils/static-1.308",
      "emoji-regex": "/emoji-regex/static-1.7",
      "floating-ui": "/floating-ui/static-1.5",
      "flux-actions": "/flux-actions/static-1.228",
      "foundations-assets": "/foundations-assets/static-1.1070",
      "foundations-components": "/foundations-components/static-1.1947",
      "foundations-theming": "/foundations-theming/static-1.179",
      "framer-motion": "/framer-motion/static-1.21",
      "head-dlb": "/head-dlb/static-1.1391",
      "HeadJS": "/HeadJS/static-2.459",
      "help-widget-components": "/help-widget-components/static-1.9026",
      "history": "/history/static-4.15",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hs-promise-utils": "/hs-promise-utils/static-1.1534",
      "hs-story-utils": "/hs-story-utils/static-1.4727",
      "hs-test-utils": "/hs-test-utils/static-1.3859",
      "hub-http-janus": "/hub-http-janus/static-1.512",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.482",
      "hubspot-dlb": "/hubspot-dlb/static-1.1019",
      "hubspotter-http": "/hubspotter-http/static-1.1443",
      "HubStyle": "/HubStyle/static-2.7728",
      "HubStyleTokens": "/HubStyleTokens/static-2.7418",
      "I18n": "/I18n/static-7.1189",
      "i18n-data": "/i18n-data/static-1.175",
      "icons": "/icons/static-2.577",
      "immer": "/immer/static-1.33",
      "jasmine": "/jasmine/static-4.795",
      "jasmine-immutable": "/jasmine-immutable/static-1.295",
      "jasmine-runner": "/jasmine-runner/static-1.2390",
      "moment-timezone": "/moment-timezone/static-5.17",
      "msw": "/msw/static-1.39",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "permission-components": "/permission-components/static-1.1678",
      "quartz": "/quartz/static-1.2768",
      "react-aria": "/react-aria/static-1.24",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.11707",
      "react-select-plus": "/react-select-plus/static-1.41",
      "react-transition-group": "/react-transition-group/static-2.8",
      "react-utils": "/react-utils/static-2.2104",
      "react-virtualized": "/react-virtualized/static-2.26",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-thunk": "/redux-thunk/static-2.17",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "rxjs": "/rxjs/static-5.10",
      "salesImages": "/salesImages/static-1.479",
      "sanitize": "/sanitize/static-1.6",
      "sanitize-text": "/sanitize-text/static-1.4556",
      "sassPrefix": "/sassPrefix/static-1.110",
      "signup-constants": "/signup-constants/static-1.11297",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.13309",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.4275",
      "StyleGuideUI": "/StyleGuideUI/static-3.409",
      "tanstack-table": "/tanstack-table/static-1.1",
      "testing-library": "/testing-library/static-1.102",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.5866",
      "ui-fonts": "/ui-fonts/static-1.322",
      "ui-images": "/ui-images/static-2.708",
      "UIComponents": "/UIComponents/static-3.4369",
      "urlinator": "/urlinator/static-1.999",
      "usage-tracker": "/usage-tracker/static-1.3310",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.1727",
      "usage-tracker-core": "/usage-tracker-core/static-1.3160",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.1726",
      "usage-tracker-public": "/usage-tracker-public/static-1.3121",
      "viral-links-lib": "/viral-links-lib/static-1.2446",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.2653",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.2463",
      "webpack-env": "/webpack-env/static-1.4",
      "classnames": "/classnames/static-2.10",
      "enviro": "/enviro/static-4.247",
      "hub-http": "/hub-http/static-1.2184",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.4861",
      "PortalIdParser": "/PortalIdParser/static-2.227",
      "raven": "/raven/static-3.1416",
      "react": "/react/static-7.123",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "styled-components": "/styled-components/static-2.40",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.1385",
      "raven-hubspot": "/raven-hubspot/static-1.1723",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.647",
      "moment": "/moment/static-3.26",
      "bend-plugin-uicomponents": "/bend-plugin-uicomponents/static-1.498"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};